module.exports = __webpack_public_path__ + "img/ic_visa.df555961.svg";